import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  extractCalendarYearFromISO,
  getCurrentCalendarYear,
  getDefaultYearRange,
  getYearEndISO,
  getYearOptions,
  getYearStartISO,
  isPersianCalendar,
} from "utils/yearRangeDates";

export const useYearRangeDates = (pastYears = 5) => {
  const { i18n } = useTranslation();
  const language = i18n.language;

  return useMemo(
    () => ({
      language,
      isPersian: isPersianCalendar(language),
      currentYear: getCurrentCalendarYear(language),
      defaultRange: getDefaultYearRange(language),
      years: getYearOptions(language, pastYears),
      getYearStartISO: (year: number) => getYearStartISO(year, language),
      getYearEndISO: (year: number) => getYearEndISO(year, language),
      extractYearFromISO: (isoString: string) =>
        extractCalendarYearFromISO(isoString, language),
    }),
    [language, pastYears]
  );
};
